import { render } from "./PrimaxConfig.vue?vue&type=template&id=21f0ce22"
const script = {}

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__